// features/cart/cartSlice.js
import { createSlice } from '@reduxjs/toolkit';

// Load initial state from localStorage
const loadState = () => {
  try {
    const serializedState = localStorage.getItem('cart');
    if (serializedState === null) {
      return { items: [] };
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return { items: [] };
  }
};

// Save state to localStorage
const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('cart', serializedState);
  } catch (err) {
    // Handle write errors
    console.log('Error saving cart state:', err);
  }
};

const initialState = loadState();

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart(state, action) {
      const newItem = action.payload;
      const existingItem = state.items.find(item => item._id === newItem._id);
      
      if (existingItem) {
        // If item exists, update the quantity
        existingItem.quantity = (existingItem.quantity || 1) + (newItem.quantity || 1);
      } else {
        // If item doesn't exist, add it with quantity
        state.items.push({
          ...newItem,
          quantity: newItem.quantity || 1
        });
      }
      // Save to localStorage after adding
      saveState(state);
    },
    removeFromCart(state, action) {
      state.items = state.items.filter(item => item._id !== action.payload);
      // Save to localStorage after removing
      saveState(state);
    },
    updateQuantity(state, action) {
      const { id, quantity } = action.payload;
      const item = state.items.find(item => item._id === id);
      if (item) {
        item.quantity = quantity;
      }
      // Save to localStorage after updating quantity
      saveState(state);
    },
    clearCart(state) {
      state.items = [];
      // Clear localStorage when clearing cart
      localStorage.removeItem('cart');
    },
  },
});

export const { addToCart, removeFromCart, updateQuantity, clearCart } = cartSlice.actions;
export default cartSlice.reducer;
